<template xmlns="http://www.w3.org/1999/html">
    <tr>
        <td class="first-column">
            {{material.name}}<i class="fa fa-times remove-icon" aria-hidden="true" @click="deleteMaterial(materialId)"></i>
        </td>
        <ProjectMaterialCostCell v-for="date in calendar" :key="date.index" :date="date" :materialId="materialId" :timeframe="timeframe"></ProjectMaterialCostCell>
    </tr>
</template>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';
import VueNotifications from 'vue-notifications';
import ProjectMaterialCostCell from './ProjectMaterialCostCell';

export default {
  name: 'ProjectMaterialCostsRow',
  props: {
    materialId: '', 
    timeframe: '',
  },
  components: {
    ProjectMaterialCostCell,
  },
  computed: {
    ...mapGetters('ProjectMaterials', ['projectMaterials']),
    ...mapGetters('Worklogs', ['calendar']),
    material() {
      return this.projectMaterials[this.materialId];
    }
  },
  methods: {
    ...mapActions('ProjectMaterials', ['DELETE_PROJECT_MATERIAL']),
    deleteMaterial(materialId) {
      const _this = this;
      _this.DELETE_PROJECT_MATERIAL(materialId).then(() => {}, (reason) => {
        _this.showErrorMsg({
          title: 'Delete project material status!',
          message: reason
        });
      });
    },
  },
  notifications: {
    showSuccessMsg: { type: VueNotifications.types.success },
    showInfoMsg: { type: VueNotifications.types.info },
    showWarnMsg: { type: VueNotifications.types.warn },
    showErrorMsg: { type: VueNotifications.types.error }
  },
  mounted() {
            
  },
};
</script>
<style scoped>
    td{
        padding: 0;
    }
    .first-column {
        position: sticky;
        position: -webkit-sticky;
        left: 0;
        z-index: 1;
        background: white;
    }
    .remove-icon:hover {
        cursor: pointer;
        color: #ee0044;
    }
</style>
